// extracted by mini-css-extract-plugin
export default {"Stroke":"GitActionLoadingIcon_Stroke__RFMAb","Refresh":"GitActionLoadingIcon_Refresh__MLrjc"};